module.exports = __webpack_public_path__ + "d10f570a7f9fc9123f002a0c30d030dd.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Italic.eot
// module id = 711
// module chunks = 0